import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=f9435614&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=ts&"
export * from "./Coupons.vue?vue&type=script&lang=ts&"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=f9435614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9435614",
  null
  
)

export default component.exports